module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticClass: "title"
  }, [_vm._v("KALKULATOR INSTALACJI FOTOWOLTAICZNEJ")])], 1), _vm._v(" "), _c('v-container', [_c('v-text-field', {
    attrs: {
      "label": "Roczny koszt energii [zł]",
      "type": "number"
    },
    model: {
      value: (_vm.koszt),
      callback: function($$v) {
        _vm.koszt = $$v
      },
      expression: "koszt"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Roczne zużycie energii [kWh]",
      "type": "number"
    },
    model: {
      value: (_vm.koszt),
      callback: function($$v) {
        _vm.koszt = $$v
      },
      expression: "koszt"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Moc istalacji [kW]",
      "type": "number"
    },
    model: {
      value: (_vm.moc),
      callback: function($$v) {
        _vm.moc = $$v
      },
      expression: "moc"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "E-mail klienta",
      "type": "email"
    },
    model: {
      value: (_vm.moc),
      callback: function($$v) {
        _vm.moc = $$v
      },
      expression: "moc"
    }
  }), _vm._v(" "), _c('v-btn', [_vm._v("Wyślij")])], 1)], 1), _vm._v(" "), (!_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed558526"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 163
// module chunks = 1